export default class AutoplayOptions {
    public autoplays: number;
    public maxAutoplays: number;
    public autoplaySteps: number[];
    public defaultAutoplayStep: number;

    public lossLimit: number;
    public singleWinLimit: number;
    public totalWinLimit: number;

    public stopOnFeatureWin: boolean;
    public stopOnAnyWin: boolean;
    public stopOnJackpotWin:boolean;
}



// WEBPACK FOOTER //
// ./~/slotworks/components/betbar/vo/autoplay-options.ts